
import React from 'react';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { Introduction } from './introduction';

export const Dashboard: React.FC = () => {
  return (
    <div>
      <div className="grid">
        <div className="grid-title">
          <Text tagName="h2" textStyle="Heading.M">
            Modeling results for email audience generation
          </Text>
        </div>
        <div className='grid-buttons'>
          <div className='nav-button'>
            <Button size="small" type="secondary">
              Settings
            </Button>
          </div>
          <div className='nav-button'>
            <Button size="small" href="#/ppsdashboard" type="emphasised">
              PPS Results
            </Button>
          </div>
        </div>
      </div>
      <div className="grid">
        <Introduction/>
      </div>
    </div>
  );
}